module.exports = __webpack_public_path__ + "static/media/ebet.7f465ebb.jpeg";